export default "__VITE_ASSET__CmuCPk7P__"